function meanRounded(values) {
  if (!values.length) return null;
  const total = values.reduce((sum, value) => sum + value, 0);
  return Math.round((total / values.length) * 10) / 10;
}

function splitTopBottom(sorted) {
  return {
    top: sorted.slice(0, 3),
    bottom: sorted.slice(Math.max(3, sorted.length - 3)).reverse(),
  };
}

/**
 * Mean of each student's AI Score (all). A submission with no stored
 * assessment is absent, the same way its card hides that bar.
 */
export function classAiAverageAll(progressById) {
  const values = [];
  Object.values(progressById || {}).forEach((entry) => {
    const value = entry && entry.aiPercentAll;
    if (value === null || value === undefined || value === '') return;
    const number = Number(value);
    if (Number.isFinite(number)) values.push(number);
  });
  return meanRounded(values);
}

/**
 * Mean of each student's marks on the questions they answered, as a
 * percentage. Denominators differ per student, so this cannot be one
 * shared "earned/max".
 */
export function classPaperAnsweredPercent(progressById) {
  const percents = [];
  Object.values(progressById || {}).forEach((entry) => {
    if (!entry) return;
    const max = Number(entry.maxMarksAnswered);
    const earned = Number(entry.earnedMarksAnswered);
    if (!(max > 0) || !Number.isFinite(earned)) return;
    percents.push((earned / max) * 100);
  });
  return meanRounded(percents);
}

/**
 * Per-question AI Score (all): each assessed student contributes their
 * slot, and a question they skipped contributes 0. Ranked high to low.
 */
export function classQuestionRanksAll(progressById) {
  const byId = {};
  Object.values(progressById || {}).forEach((entry) => {
    if (!entry || entry.aiPercentAll === null || entry.aiPercentAll === undefined) return;
    (entry.questions || []).forEach((question) => {
      if (!question || question.aiAll === null || question.aiAll === undefined) return;
      const id = String(question.id);
      if (!byId[id]) {
        byId[id] = {
          text: question.text || '',
          fullText: question.fullText || '',
          total: 0,
          count: 0,
        };
      }
      byId[id].total += Number(question.aiAll);
      byId[id].count += 1;
      if ((question.fullText || '').length > byId[id].fullText.length) {
        byId[id].fullText = question.fullText;
        byId[id].text = question.text || byId[id].text;
      }
    });
  });

  const sorted = Object.values(byId)
    .filter((question) => question.count > 0)
    .map((question) => ({
      text: question.text,
      fullText: question.fullText,
      average: Math.round((question.total / question.count) * 10) / 10,
      count: question.count,
    }))
    .sort((a, b) => b.average - a.average || String(a.fullText).localeCompare(String(b.fullText)));

  return splitTopBottom(sorted);
}

/** Per-student AI Score (all), ranked high to low. */
export function classStudentRanksAll(progressById) {
  const sorted = Object.values(progressById || {})
    .filter((entry) => entry && entry.aiPercentAll !== null && entry.aiPercentAll !== undefined)
    .map((entry) => ({
      name: entry.userName || '',
      average: Number(entry.aiPercentAll),
      count: entry.aiAllQuestionCount || 0,
    }))
    .filter((entry) => Number.isFinite(entry.average))
    .sort((a, b) => b.average - a.average || String(a.name).localeCompare(String(b.name)));

  return splitTopBottom(sorted);
}
